import parseHTMLToReact from "html-react-parser";
import { Card, Flex } from "orcs-design-system";
import PropTypes from "prop-types";
import React, { useEffect, useMemo, useState } from "react";
import styled from "styled-components";

import AIDashboardProvider from "./context/AIDashboardProvider";
import DataDrivenDashboardRenderer from "./DataDrivenDashboardRenderer";
import { createHtmlParsingOptions } from "./utils/dashboardHtmlParsingOptions";
import { jsonComponentRegistry } from "./utils/jsonComponentRegistry";
import { renderDashboardTree } from "./utils/renderDashboardTree";
import { safeParseDashboardJson } from "./utils/safeParseDashboardJson";

const StyledFlex = styled(Flex)`
  width: 100%;
  overflow: auto;

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    a {
      font-size: inherit !important;
      font-weight: inherit !important;
    }
  }
`;

const isTemplateDashboard = (jsonTree) =>
  Array.isArray(jsonTree?.data) && typeof jsonTree?.template === "string";

const AIDashboardCanvas = ({ chatId, dashboardId, content, dashboard }) => {
  const [Content, setContent] = useState(null);

  const jsonTree = useMemo(() => safeParseDashboardJson(content), [content]);

  useEffect(() => {
    if (!content) {
      setContent(null);
      return;
    }

    if (jsonTree && !isTemplateDashboard(jsonTree)) {
      setContent(renderDashboardTree(jsonTree, jsonComponentRegistry));
    } else if (!jsonTree) {
      setContent(parseHTMLToReact(content.trim(), createHtmlParsingOptions()));
    }
  }, [content, jsonTree]);

  const isTemplate = dashboard?.template && `${dashboard?.template}` !== "null";

  return (
    <AIDashboardProvider chatId={chatId} dashboardId={dashboardId}>
      {isTemplate ? (
        <DataDrivenDashboardRenderer dashboard={dashboard} />
      ) : (
        Content
      )}
    </AIDashboardProvider>
  );
};

AIDashboardCanvas.propTypes = {
  chatId: PropTypes.string.isRequired,
  dashboardId: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  dashboard: PropTypes.shape({
    css: PropTypes.string.isRequired,
    queries: PropTypes.string.isRequired,
    template: PropTypes.string.isRequired,
  }).isRequired,
};

export default AIDashboardCanvas;
